import { render } from "./CreateTicketModal.vue?vue&type=template&id=0f1275f6"
import script from "./CreateTicketModal.vue?vue&type=script&lang=js"
export * from "./CreateTicketModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/modals/CreateTicketModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f1275f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f1275f6', __exports__)) {
    api.reload('0f1275f6', __exports__)
  }
  
  module.hot.accept("./CreateTicketModal.vue?vue&type=template&id=0f1275f6", () => {
    api.rerender('0f1275f6', render)
  })

}


export default __exports__